<template>
  <div :class="['common-header', theme, rootClass]">
    <div class="common-header-wrapper" :style='rootStyle'>
      <!-- 移动端左边插槽，有插槽无汉堡包 -->
      <slot name="left">
        <div class="icon-mobile" @click="isMenuMobileShow = !isMenuMobileShow" :class="{'is-active': isMenuMobileShow}">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </slot>
      <a :href='logoHref || "https://geekbang.org/"' class="common-logo" :style='logoStyle'></a>
      <div class="info">
        <div class="menu">
          <a :href="item.link" :class='[{hidden: !showMenu}, {on: location === item.link}, pcMenuStyle]' v-for="(item, i) in menu" :key='i' target="_black" @click="menuClick(item, $event)">{{ item.name }}</a>
          <slot name='search'></slot>
        </div>
        <div class="userinfo">
          <!-- 这里两个templete一个是a标签跳转，一个是router-link跳转，适用于账户中心 -->
          <template v-if='!navRouterLink'>
            <span v-if="!loginUser" class="control">
              <a class="pc" :href="`https://account.geekbang.org/signin?redirect=${encodeURIComponent(location)}`">
                登录
              </a>
              <a class='pc line'>|</a>
              <a class="pc" :href="`https://account.geekbang.org/signup?redirect=${encodeURIComponent(location)}`">
                注册
              </a>
              <a class="mobile" :href="`https://account.geekbang.org/signin?redirect=${encodeURIComponent(location)}`">
                登录
              </a>
            </span>
            <!-- <a v-else href="//account.geekbang.org/dashboard" class="profile"></a> -->
            <div v-else class="profile">
              <a href="https://account.geekbang.org/dashboard">
                <i class="icon-font icon-profile">&#xe648;</i>
              </a>
              <div class="profile-dropdown">
                <i class='arrow'></i>
                <slot name="profile-dropdown-eachlist"></slot>
                <a href="https://account.geekbang.org/dashboard/info">
                  <i class="icon-font">&#xe64a;</i>
                  基本信息
                </a>
                <a href="https://account.geekbang.org/dashboard/setting">
                  <i class="icon-font">&#xe649;</i>
                  账号设置
                </a>
                <a :href="`https://account.geekbang.org/logout?redirect=${encodeURIComponent(location)}`">
                  <i class="icon-font">&#xe64b;</i>
                  退出登录
                </a>
              </div>
            </div>
          </template>
          <template v-else>
            <span v-if="!loginUser" class="control">
              <router-link class="pc" to='/signin'>登录</router-link>
              <a class='pc line'>|</a>
              <router-link class="pc" to='/signup'>注册</router-link>
              <router-link class="mobile" to='/signin'>登录</router-link>
            </span>
            <!-- <a v-else href="//account.geekbang.org/dashboard" class="profile"></a> -->
            <div v-else class="profile">
              <a>
                <i class="icon-font icon-profile">&#xe648;</i>
              </a>
              <div class="profile-dropdown">
                <i class='arrow'></i>
                <router-link to='/dashboard/info'>
                  <i class="icon-font">&#xe64a;</i>
                  基本信息
                </router-link>
                <router-link to='/dashboard/setting'>
                  <i class="icon-font">&#xe649;</i>
                  账号设置
                </router-link>
                <a @click='logout'>
                  <i class="icon-font">&#xe64a;</i>
                  退出登录
                </a>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-if="isMenuMobileShow" class="menu-mobile" @click.self="blackCover">
        <ul>
          <li v-for="(item, i) in menu" :class='{hidden: !showMenu}' :key="i">
            <a :href="item.link" target="_black" @click="menuClick(item, $event)">{{ item.name }}</a>
          </li>
          <slot name='searchmobile'></slot>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'white' // white, black, opacity
    },
    showMenu: {
      type: Boolean,
      default: true
    },
    navRouterLink: {
      type: Boolean,
      default: false
    },
    loginUser: {
      type: Boolean,
      default: false
    },
    logout: {
      type: Function,
      default: null
    },
    rootStyle: {
      type: Object,
      default: null
    },
    rootClass: {
      type: String,
      default: null
    },
    logoStyle: {
      type: Object,
      default: () => {}
    },
    logoHref: {
      type: String,
      default: ''
    },
    pcMenuStyle: {
      type: String,
      default: ''
    },
    menu: {
      type: Array,
      default: () => {
        return [
          { link: 'https://www.geekbang.org/', name: '首页' },
          { link: 'https://time.geekbang.org/', name: '极客时间' },
          { link: 'https://s.geekbang.org/', name: '极客搜索' },
          { link: 'http://www.infoq.com/cn', name: '技术媒体' },
          { link: 'http://new.stuq.org', name: '在线课程' },
          { link: 'http://ego.geekbang.org/together', name: '高端会员' },
          { link: 'https://time.geekbang.org/gift/card', name: '阅码兑换' }
        ]
      }
    }
  },
  data () {
    return {
      isMenuMobileShow: false
    }
  },
  computed: {
    location () {
      return window.location.href
    }
  },
  watch: {
    isMenuMobileShow (newVal) {
      if (newVal) {
        document.documentElement.style.height = '100%'
        document.body.style.height = '100%'
        document.body.style.overflow = 'hidden'
      } else {
        document.documentElement.removeAttribute('style')
        document.body.removeAttribute('style')
      }
    }
  },
  methods: {
    blackCover () {
      this.$emit('blackClick')
    },
    menuClick (item, e) {
      this.$emit('menuClick', item, e)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/font/icon.css";
a{
  text-decoration: none;
}
.hidden{
  display: none;
}

.common-header {
  height: 4.75rem;
  background-color: #fff;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
  border-bottom: 1px solid #eaeaea;
  .common-header-wrapper {
    width: 94vw;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .icon-mobile,
    .menu-mobile {
      display: none;
    }

    .common-logo {
      flex-shrink: 0;
      width: 9.4375rem;
      height: 4.75rem;
      background-image: url('https://static001.geekbang.org/static/www/img/logo1.b8d5e40.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    .info {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .menu {
        margin-right: 1rem;
        a {
          padding: 0.5rem 1rem;
          font-weight: 400;
          transition: color 0.2s ease;
          &:link,
          &:visited {
            color: #353535;
          }
          &:hover {
            color: #ff5a05;
          }
          &.on {
            color: #ff5a05 !important;
          }
        }
      }

      .userinfo {
        height: 4.75rem;
        line-height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        .control {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          a {
            font-size: 1rem;
            color: #353535;
            display: block;
            height: 4.75rem;
            line-height: 4.75rem;
            &.mobile {
              display: none;
            }

            &.line {
              font-size: 1.2rem;
              margin-left: 0.5rem;
              margin-right: 0.5rem;
            }
          }
        }

        .profile {
          display: flex;
          height: 100%;
          align-items: center;
          justify-content: center;
          position: relative;
          cursor: pointer;
          &:hover {
            .profile-dropdown {
              display: flex;
            }
          }
          .profile-dropdown {
            z-index: 10;
            display: none;
            position: absolute;
            width: 10.1875rem;
            flex-direction: column;
            background-color: #fff;
            box-shadow: 0 4px 42px 6px rgba(10, 10, 10, 0.1);
            top: 5rem;
            right: -2.1rem;
            .arrow {
              cursor: pointer;
              width: 1.6rem;
              height: 1.6rem;
              background-color: #ffffff;
              transform: rotate(45deg);
              position: absolute;
              right: 2rem;
              top: -0.8rem;
            }
            a {
              position: relative;
              font-size: 1rem;
              line-height: 3;
              border-bottom: 1px solid #e8e8e8;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              padding-left: 1.25rem;
              padding-right: 2.3125rem;
              color: #353535;
              cursor: pointer;
              &:hover {
                color: #ff5a05;
                .icon-font, .iconfont {
                  color: #ff5a05;
                }
              }
              .icon-font, .iconfont {
                color: #888;
                font-size: 1.25rem;
              }
              &.router-link-active{
                color: #ff5a05;
                .icon-font, .iconfont {
                  color: #ff5a05;
                }
              }
              &:last-child {
                border-bottom: none;
              }
            }
          }
        }

        i.icon-profile {
          color: #888;
          font-size: 1.5rem;
          display: block;
        }
      }
    }
  }
  // 透明主题
  &.opacity {
    background-color: transparent;
    border-bottom: none;
    .common-header-wrapper {
      .icon-mobile{
        span{
          background-color: #ffffff;
        }
      }
      .common-logo {
        background-image: url(https://static001.geekbang.org/static/live/img/logo.bb6fd3f.png);
      }
      .info {
        .menu {
          a{
            color: #fff;
            &:link,
            &:visited {
              color: #fff;
            }
            &:hover {
              color: #ff5a05;
            }
          }
        }
        .userinfo{
          .control{
            a{
              color: #fff;
            }
          }
        }
        .profile {
          i.icon-profile{
            color: #fff;
          }
        }
      }
    }
  }
  // 黑色主题
  &.black {
    background-color: #1e1e1e;
    border-bottom: none;
    .common-header-wrapper {
      .icon-mobile{
        span{
          background-color: #ffffff;
        }
      }
      .common-logo {
        background-image: url(https://static001.geekbang.org/static/live/img/logo.bb6fd3f.png);
      }
      .info {
        .menu {
          a:link,
          a:visited {
            color: #fff;
          }
          a:hover {
            color: #ff5a05;
          }
        }
        .userinfo{
          .control{
            a{
              color: #fff;
            }
          }
        }
        .profile {
          i.icon-profile{
            color: #fff;
          }
          .profile-dropdown {
            background-color: #1e1e1e;
            .arrow {
              background-color: #1e1e1e;
            }
            a {
              border-bottom: #353535 solid 1px;
              &:link,
              &:visited {
                color: #fff;
              }
              &:hover {
                color: #ff5a05;
                background-color: #353535;
              }
              .icon-font, .iconfont {
                color: #888;
                font-size: 1.25rem;
              }
            }
          }
        }
      }
    }
  }
}
@media all and (max-width: 960px) {
  .common-header .common-header-wrapper .info .menu a{
    padding: 0.5rem 0.5rem;
  }
}
@media all and (max-width: 835px) {
  .common-header .common-header-wrapper .info .menu a{
    padding: 0.5rem 0.25rem;
  }
}
@media all and (max-width: 768px) {
  .common-header {
    height: 3rem;
    border-bottom: none;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);
    z-index: 1;
    background-color: #fff;

    .common-header-wrapper {
      .icon-mobile {
        display: block;
        position: relative;
        cursor: pointer;
        width: 1rem;
        height: 1rem;
        span {
          display: inline-block;
          position: absolute;
          width: 16px;
          height: 1px;
          background-color: #000;
          transition: all .35s;
          left: 0;
          &:nth-child(1) {
            top: 2px;
          }
          &:nth-child(2) {
            top: 8px;
          }
          &:nth-child(3) {
            top: 14px;
          }
        }
        &.is-active{
          z-index: 11;
          span{
            background-color: #fff;
            &:nth-child(1) {
              transform-origin: left top;
              transform: rotate(45deg);
            }
            &:nth-child(2) {
              display: none;
            }
            &:nth-child(3) {
              top: 13px;
              transform-origin: left bottom;
              transform: rotate(-45deg);
            }
          }
        }
      }
      .menu-mobile {
        display: flex;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .9);
        z-index: 10;
        align-items: center;
        ul {
          margin: 0 2.5rem;
          margin-top: -4vh;
          width: 100%;
          list-style: none;
          list-style-position: inside;
          padding: 0;
          li{
            line-height: 1.5;
            padding: 1rem 0.2rem .6rem;
            border-bottom: 1px solid #353535;
            font-size: 1rem;
            text-align: left;
            font-size: 14px;
            a{
              color: #fff;
            }
          }
        }
      }

      .common-logo {
        width: 4.90625rem;
        height: 1.25rem;
        position: absolute;
        left: 50%;
        top: 1rem;
        transform: translate(-50%);
      }
      .info {
        height: 100%;
        .menu {
          display: none;
        }
        .userinfo {
          height: 100%;
          .control {
            height: 100%;
            a {
              &.mobile {
                display: inline-block;
                // margin-right: 0.5rem;
                font-size: 0.875rem;
              }
              &.pc {
                display: none;
              }
            }
          }
          .profile {
            &:hover {
              .profile-dropdown {
                display: none;
              }
            }
          }
          i.icon-profile {
            font-size: 1rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Header.vue?5685f8dc